import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useCallback, useState } from 'react';

import { useUserList } from '@/api/user';
import {
  InstantSearch,
  InstantSearchSortOrder,
  type QueryState,
  type SolQueryParamsNew,
} from '@/components/InstantSearch';
import { getSolQueryParamsNewFromQueryState } from '@/components/InstantSearch/util/search-util';
import { Page } from '@/components/page';
import { Panel } from '@/components/panels';

import UsersListHeader from './UsersListHeader';
import UsersListTable from './UsersListTable';

const DEFAULT_QUERY_STATE: Partial<QueryState> = {
  size: 20,
  sortBy: 'name',
  sortOrder: InstantSearchSortOrder.ASC,
};

const UsersList = () => {
  const [tableParams, setTableParams] = useState<SolQueryParamsNew>();
  const { userListData, totalResults, isLoading, error } = useUserList(tableParams);

  const handleQueryStateChange = useCallback(
    (queryState: Required<QueryState>) => {
      const tableParams = getSolQueryParamsNewFromQueryState(queryState);
      setTableParams(tableParams);
    },
    [setTableParams],
  );

  return (
    <Page title={t`Settings`} pageName={t`Users & Roles`} exampleAIQuestions={[]}>
      <InstantSearch
        prefix="u"
        defaultQueryState={DEFAULT_QUERY_STATE}
        onQueryStateChange={handleQueryStateChange}
      >
        <div className="flex flex-col gap-6">
          <UsersListHeader />
          <Panel title={<Trans>Account Users</Trans>} isFullHeight>
            <UsersListTable
              data={userListData}
              totalResults={totalResults}
              isLoading={isLoading}
              error={error}
            />
          </Panel>
        </div>
      </InstantSearch>
    </Page>
  );
};

export default UsersList;
